// import icons
import {
  FaYoutube,
  FaFacebookF,
  FaInstagram,
  FaPinterestP,
  FaDiscord,
} from 'react-icons/fa';

// import images
import AboutImg from '../src/assets/img/about/chopsticks3.png';
import ModelWhiteImg from '../src/assets/img/model-white.png';
import ModelBlackImg from '../src/assets/img/model-black.png';
import MenuImg1 from '../src/assets/img/menu/drinkMenu.jpg';
import MenuImg2 from '../src/assets/img/menu/thaicoonClaypot.png';
import MenuImg3 from '../src/assets/img/menu/lobsterRoll.png';
import MenuImg4 from '../src/assets/img/menu/3.png';
// import MenuImg5 from '../src/assets/img/menu/kidsBoat.png';

// import DynamicImg from '../src/assets/img/menu/CapeCod.webp';
import SignatureImg from '../src/assets/img/team/signatureKnox.png';
import ChefImg from '../src/assets/img/team/Mr.Knox.jpg';
import Avatar1 from '../src/assets/img/testimonial/avatar1.png';
import Avatar2 from '../src/assets/img/testimonial/avatar2.png';
import Avatar3 from '../src/assets/img/testimonial/avatar3.png';

//Menu Modal pics
import sushiSashimiTempura from '../src/assets/img/menuModal/lunchSpecial/sushiSashimiTempura.png'

export const navData = [
  { refKey: 'heroRef', name: 'Home' },
  { refKey: 'aboutRef', name: 'About' },
  // Uncomment and use when ready
  // { refKey: 'servicesRef', name: 'Services' },
  // Additional sections can be added as needed
  { refKey: 'menuRef', name: 'Menu' },
  { refKey: 'teamRef', name: 'Team' },
  { refKey: 'reservationRef', name: 'Reservation' },
  { refKey: 'tablesRef', name: 'Tables' },
  // Add more navigation items as you uncomment/use them in your app
];

export const heroData = {
  pretitle: 'Marietta Square',
  title: 'Thai & Sushi Bar',
  subtitle:
  'A Taste of Thai on the Square',
    // 'Online Impressions Rest On Visual Distinguishment And Utilities. Tailoring Both To Your Vision Is My Specialty',
  btnText: 'Pricing',
};

export const socialData = [
  { href: '/', icon: <FaYoutube /> },
  { href: '/', icon: <FaFacebookF /> },
  { href: '/', icon: <FaInstagram /> },
  { href: '/', icon: <FaPinterestP /> },
  { href: '/', icon: <FaDiscord /> },
];

export const aboutData = {
  pretitle: 'A Taste',
  title: 'Authentic Thai',
  subtitle:
  'Serving the Marietta Square, Thai & Sushi Bar uses only the highest quality ingredients to create our unique and delicious dishes.',
    // 'Serving the Marietta Square since 2002, Thaicoon & Sushi Bar uses only the highest quality ingredients to create our unique and delicious dishes.',
  subtitle2:
    'We offer a vast traditional delicious Thai dishes made from an array of only the freshest ingredients. Innovative  sushi rolls and small plates giving you the option for perfect infusion of cultures.',
  btnText: 'See Menu',
  image: AboutImg,
};

export const menuData = {
  title: 'Popular Dishes',
  subtitle: 'A few of our favorite things',
  modelImg: ModelWhiteImg,
  btnText: 'View complete menu',
  menuItems: [
    {
      image: MenuImg1,
      name: 'Free Web Design',
      price: 'Free Web Design',
      description: 'Your online impression counts. Let us build and maintain your optimal gateway to business.',
      identifier:'drinkMenu',
    },
    {
      image: MenuImg2,
      name: 'Reservations',
      price: 'Reservations',
      description: 'Funnel new and returning customers with an unrivaled, engaging reservation experience',
      identifier:'lunchSpecial',
    },
    {
      image: MenuImg3,
      name: 'Pricing Discounts & Stripe',
      price: 'Table Data',
      description: 'GoHost only wins when you win. With that, your success is our only goal',
      identifier:'kidsMenu',
    },
    {
      image: MenuImg4,
      name: 'Menu and Item Control',
      price: 'Menu and Item Control',
      description: 'Make real-time updates to your entire menu, including pricing, options, and item placement.',
      identifier:'thaiMenu',
    },
    // {
    //   image: MenuImg5,
    //   name: 'Dynamic Table Reserving',
    //   price: 'Kids Menu',
    //   description: 'Dynamic tier website plus table reservation. Customers will be able to create bookings and you will be able to management them',
    // },
    // {
    //   image: MenuImg4,
    //   name: 'Marketing email management',
    //   price: '$30/month',
    //   description: 'Integration of Square email management that allows access to email marketing tools ',
    // },
    // {
    //   image: MenuImg4,
    //   name: 'Email Marketing and Newsletters',
    //   price: '$150/month',
    //   description: 'Class aptent taciti ciosqu litora torquent per',
    // },
  ],
  // menuModalitems: [
  // modalBreakdown1:'Reactive, constantly SEO optimized, website features tailored to your vision. Unlimited changes of elements and content, exactly how you like.',
  // modalBreakdown2:'Dynamic tier plus giving your customers ability to sign up for automated subscription payments for your services and automically charged by a payment API integration',
  // modalBreakdown3:'Dynamic tier plus appointment/calender booking intergration. Customers will be able to create bookings under your managment',
  // modalBreakdown4:'Dynamic tier website plus table reservation. Customers will be able to create bookings and you will be able to management them',
  // ]
};

export const teamData = {
  pretitle: 'Mind Behind The Mission',
  title: 'Yours truly',
  sub1: 'I found full stack development as the perfect combination of creative outlet and value additive for businesses. Exploring the constantly evolving ways of painting data structures in the most appealing commerce usage sounded like rewarding work, and I have found the truth in that to be beyond all expectations.',
  sub2: 'Utilizing my account management background and technical literacy, achieving your vison of your online and in-house operation potential will become mine',
  name: 'Graham Knox',
  occupation: 'Digital Architect, Founder',
  signatureImg: SignatureImg,
  chefImg: ChefImg,
};

export const testimonialData = {
  title: "what client's say",
  subtitle: '1500+ statisfied clients',
  modelImg: ModelWhiteImg,
  slider: [
    {
      message:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio quas ipsum eius voluptatibus. Quod ipsum ullam id facere a beatae incidunt eaque, veritatis architecto cum perferendis debitis tempora.',
      image: Avatar1,
      name: 'Rick Thompson',
      occupation: 'CEO of Delightful',
    },
    {
      message:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio quas ipsum eius voluptatibus. Quod ipsum ullam id facere a beatae incidunt eaque, veritatis architecto cum perferendis debitis tempora.',
      image: Avatar2,
      name: 'John Doe',
      occupation: 'CEO of Delightful',
    },
    {
      message:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio quas ipsum eius voluptatibus. Quod ipsum ullam id facere a beatae incidunt eaque, veritatis architecto cum perferendis debitis tempora.',
      image: Avatar3,
      name: 'Henry A.',
      occupation: 'CEO of Delightful',
    },
  ],
};

export const servicesData = {
  pretitle: 'Take a seat',
  title: 'Reserve  your favorite table online',
  subtitle:
  'Have a favorite table in mind for your special ocassion? Want to bypass the phone call and guess work with seating arrangments?',
  subtitle2:
  'Thai introduces the power to map out your dining experience with a couple of clicks. Select your time and table and Thiacoon will text you when the table is ready!',
  btnText: 'Reserve Now',
};

export const reservationData = {
  pretitle:'lets chat',
  title: 'Book a call with me',
  subtitle:
    'Call (800) 123-4567 from 5AM - 11PM daily, or book online with OpenTable.Reservations required for parties of 6 or more.',
  modelImg: ModelBlackImg,
  btnText: 'make a reservation',
};

export const newsletterData = {
  title: "Let's get in touch",
  subtitle:"Submit your contact information along with any interest or questions on the product, onboarding process or anything else!",
  placeholder: 'Your Email',
  btnText: 'Subscribe',
};

export const footerData = {
  contact: {
    title: 'contact location',
    address: '34 Yum St., Marietta, GA 30060',
    phone: '(678)766-9898',
  },
  hours: {
    title: 'working hours',
    program: [
      {
        days: 'monday - friday',
        hours: '09:00 AM - 10:00 PM',
      },
      {
        days: 'saturday - sunday',
        hours: '09:00 AM - 11:00 PM',
      },
    ],
  },
  social: {
    title: 'social network',
    icons: [
      { href: '/', icon: <FaYoutube /> },
      { href: '/', icon: <FaFacebookF /> },
      { href: '/', icon: <FaInstagram /> },
      { href: '/', icon: <FaPinterestP /> },
      { href: '/', icon: <FaDiscord /> },
    ],
  },
};

// const tables = [
//   { id: 1, shape: 'rectangle1', position: { top: '45%', left: '6%' },className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400 ', array:"Seats: 4" },
//   { id: 2, shape: 'square', position: { top: '60%', left: '5%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
//   { id: 3, shape: 'square', position: { top: '61%', left: '16%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 3"},
//   { id: 4, shape: 'square', position: { top: '66%', left: '31%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
//   { id: 5, shape: 'square', position: { top: '66%', left: '39%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
//   { id: 6, shape: 'rectangle3', position: { top: '35%', left: '31%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 14"},
//   { id: 7, shape: 'square', position: { top: '30%', left: '41%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 2"},
//   { id: 8, shape: 'square', position: { top: '30%', left: '52%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 2"},
//   { id: 9, shape: 'square', position: { top: '30%', left: '63%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 2"},
//   { id: 10, shape: 'square', position: { top: '25%', left: '74%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
//   { id: 11, shape: 'square', position: { top: '38%', left: '75%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
//   { id: 12, shape: 'square', position: { top: '51%', left: '75%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
//   { id: 13, shape: 'square', position: { top: '67%', left: '76%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
//   { id: 14, shape: 'square', position: { top: '22%', left: '87%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 2"},
//   { id: 15, shape: 'square', position: { top: '31%', left: '87%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 2"},
//   { id: 16, shape: 'square', position: { top: '40%', left: '88%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 2"},
//   { id: 17, shape: 'square', position: { top: '53%', left: '87%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
//   { id: 18, shape: 'square', position: { top: '67%', left: '88%' }, className: 'opacity-30 blur rounded-lg text-white bg-red-300 hover:bg-yellow-400' , array:"Seats: 4"},
// ];

// const layovers = [
//   { id: 1, shape: 'text1', position: { top: '47%', left: '6%' },className: ' rounded-lg text-white ', array:"Seats: 4" },
//   { id: 2, shape: 'text1', position: { top: '60%', left: '5%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
//   { id: 3, shape: 'text1', position: { top: '61%', left: '16%' }, className: ' rounded-lg text-white ' , array:"Seats: 3"},
//   { id: 4, shape: 'text1', position: { top: '66%', left: '31%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
//   { id: 5, shape: 'text1', position: { top: '66%', left: '39%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
//   { id: 6, shape: 'text1', position: { top: '42%', left: '31%' }, className: ' rounded-lg text-white ' , array:"Seats: 14"},
//   { id: 7, shape: 'text1', position: { top: '30%', left: '41%' }, className: ' rounded-lg text-white ' , array:"Seats: 2"},
//   { id: 8, shape: 'text1', position: { top: '30%', left: '52%' }, className: ' rounded-lg text-white ' , array:"Seats: 2"},
//   { id: 9, shape: 'text1', position: { top: '30%', left: '63%' }, className: ' rounded-lg text-white ' , array:"Seats: 2"},
//   { id: 10, shape: 'text1', position: { top: '25%', left: '74%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
//   { id: 11, shape: 'text1', position: { top: '38%', left: '75%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
//   { id: 12, shape: 'text1', position: { top: '51%', left: '75%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
//   { id: 13, shape: 'text1', position: { top: '67%', left: '76%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
//   { id: 14, shape: 'text1', position: { top: '22%', left: '87%' }, className: ' rounded-lg text-white ' , array:"Seats: 2"},
//   { id: 15, shape: 'text1', position: { top: '31%', left: '87%' }, className: ' rounded-lg text-white ' , array:"Seats: 2"},
//   { id: 16, shape: 'text1', position: { top: '40%', left: '88%' }, className: ' rounded-lg text-white ' , array:"Seats: 2"},
//   { id: 17, shape: 'text1', position: { top: '53%', left: '87%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
//   { id: 18, shape: 'text1', position: { top: '67%', left: '88%' }, className: ' rounded-lg text-white ' , array:"Seats: 4"},
// ];